'use client';

import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

type SkeletonPreferencesCardProps = {
  className?: string;
  itemCount?: number;
};

// Per DESIGN.md "cards are rare": no outer card wrapper.
// Renders a vertical stack of skeleton rows, each row a small label
// skeleton followed by a full-width control skeleton. Skeletons inherit
// the primitive's canonical `bg-surface-2` fill so the pulse stays
// visible against the `surface-0` page background.
export default function SkeletonPreferencesCard({
  className,
  itemCount = 1,
}: SkeletonPreferencesCardProps) {
  const rows = Array.from({ length: itemCount }, (_, index) => (
    <div
      key={`skeleton-pref-${index}`}
      className="flex flex-col gap-2"
    >
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-9 w-full" />
    </div>
  ));

  return (
    <div className={cn('flex flex-col gap-4', className)}>
      {rows}
    </div>
  );
}
